module.exports = __webpack_public_path__ + "img/app-store.df248284.svg";